import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';
import { provideAppConfig } from '@core/config/app-config.providers';
import { provideAuth } from '@core/auth/auth.providers';
import { provideI18n } from '@core/i18n/i18n.providers';
import { provideIcons } from '@core/icons/icons.providers';
import { apiInterceptor } from '@core/interceptors/api.interceptor';
import { provideObservability } from '@core/observability/observability.providers';
import { ExternalLinkInterceptorService } from '@shared/services/external-link-interceptor.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppConfig(),
    provideAuth(),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    provideHttpClient(withInterceptors([apiInterceptor]), withInterceptorsFromDi()),
    provideObservability(),
    provideIcons(),
    provideI18n(),
    provideAppInitializer(() => inject(ExternalLinkInterceptorService).init()),
  ],
};
